import styled from 'styled-components'

export const StyledIframe = styled.iframe`
  height: 80vh;
  min-height: 500px;
`
